import { SVGProps } from 'react';

const WholeWord = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 9v6m4-8v8m8 2v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1m8-5a3 3 0 1 1-6 0 3 3 0 0 1 6 0m10 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
    />
  </svg>
);
export default WholeWord;
